/**
 * 飲み頃を整形する
 * @see https://team-lab.backlog.com/view/ENOTECA_ALL-14510
 */
export const formatWhenToDrink = (whenToDrink?: string): string | undefined => {
  if (!whenToDrink) return;

  if (/〜|~/.test(whenToDrink)) {
    const whenToDrinkTo = whenToDrink.split(/〜|~/).slice(-1)[0];

    return whenToDrinkTo ? `〜${whenToDrinkTo}年` : whenToDrink;
  }

  return `${whenToDrink}年`;
};
